import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight, Menu, X } from 'lucide-react';

const NAV_LINKS = [
  { label: 'Features', href: '/features' },
  { label: 'How It Works', href: '/how-it-works' },
  { label: 'Pricing', href: '/pricing' },
];

export default function MarketingNav({ activePage }) {
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-lg" style={{ backgroundColor: 'rgba(25,82,89,0.97)' }}>
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
        <a href="/"><img src="/logos/funnely-white.png" alt="Funnely" className="h-6 object-contain" /></a>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8 text-sm absolute left-1/2 -translate-x-1/2">
          {NAV_LINKS.map(link => (
            <a key={link.href} href={link.href} className={`transition-colors ${activePage === link.href ? 'text-white' : 'text-white/60 hover:text-white'}`}>{link.label}</a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <Button variant="ghost" size="sm" className="text-white/80 hover:bg-white/10 hover:text-white hidden sm:inline-flex" onClick={() => navigate('/login')}>Log In</Button>
          <Button size="sm" className="font-semibold text-[#195259] rounded-full hidden sm:inline-flex" style={{ backgroundColor: '#FF9A00' }} onClick={() => navigate('/register')}>Get Started <ArrowRight className="h-3.5 w-3.5 ml-1" /></Button>
          {/* Mobile hamburger */}
          <button onClick={() => setMobileOpen(!mobileOpen)} className="md:hidden p-2 rounded-lg hover:bg-white/10 transition-colors" data-testid="mobile-menu-toggle">
            {mobileOpen ? <X className="h-5 w-5 text-white" /> : <Menu className="h-5 w-5 text-white" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden border-t border-white/10" style={{ backgroundColor: 'rgba(25,82,89,0.99)' }} data-testid="mobile-menu">
          <div className="px-4 py-4 space-y-1">
            {NAV_LINKS.map(link => (
              <a key={link.href} href={link.href} onClick={() => setMobileOpen(false)}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${activePage === link.href ? 'text-white bg-white/10' : 'text-white/70 hover:text-white hover:bg-white/5'}`}>
                {link.label}
              </a>
            ))}
            <div className="pt-3 border-t border-white/10 flex flex-col gap-2">
              <Button variant="ghost" className="w-full justify-center text-white hover:bg-white/10" onClick={() => { setMobileOpen(false); navigate('/login'); }}>Log In</Button>
              <Button className="w-full justify-center font-semibold text-[#195259] rounded-full" style={{ backgroundColor: '#FF9A00' }} onClick={() => { setMobileOpen(false); navigate('/register'); }}>Get Started <ArrowRight className="h-3.5 w-3.5 ml-1" /></Button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
